import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

export async function listarClinicas() {
  const { data } = await api.get("/clinicas");
  return data;
}

export async function listarServicosOnline() {
  const { data } = await api.get("/servicos", {
    params: { marcacao_online: true },
  });
  return data;
}

export async function listarTodosServicos() {
  const { data } = await api.get("/servicos");
  return data;
}

export async function getDisponibilidade({ clinica, servico, data }) {
  const { data: payload } = await api.get("/disponibilidade", {
    params: { clinica, servico, data },
  });
  return payload;
}

export async function criarMarcacao(payload) {
  const { data } = await api.post("/marcacoes", payload);
  return data;
}

export async function getMarcacaoPorToken(token) {
  const { data } = await api.get(`/marcacoes/token/${token}`);
  return data;
}

export async function cancelarMarcacao(token) {
  const { data } = await api.post(`/marcacoes/token/${token}/cancelar`);
  return data;
}

export async function reagendarMarcacao(token, data_hora) {
  const { data } = await api.post(`/marcacoes/token/${token}/reagendar`, {
    data_hora,
  });
  return data;
}

export const icsUrl = (token) => `${BASE}/marcacoes/token/${token}/ics`;
